// News Store - basically posts + web clippings
import { findIndex } from 'lodash'
import store from 'customerPath/store'

const state = {
  filterActive: false,
  filterOptions: [],
  filters: {},
  horizontalTeaser: {
    results: {
      title: '',
      description: '',
      articles: [],
    },
    options: {
      maxRecords: 2,
    },
  },
  webNews: {
    results: {
      title: '',
      news: [],
    },
    options: {
      maxRecords: 7,
    },
  },
  news: [],
  newsItem: null,
  pagination: {},
  pending: false,
  topTeaser: {
    results: [],
    options: {
      isCircle: true,
      sliderInterval: 5000,
    },
  },
}

const getters = {}

/* Create actions dynamically */
const actions = {
  getNewsItem({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING', true)
      this.api.items
      .getItem(`news.${id}`)
      .then(({ data }) => {
        commit('SET_NEWS_ITEM', data)
        resolve()
      })
      .catch(({ response }) => {
        store.dispatch('app/setError', response.status)
        reject(response)
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
  getNews({ commit }, params) {
    if (!params || params.page === 1) {
      // Flush news in state if a fresh call to page 1 is requested
      commit('SET_NEWS', { results: [], pagination: { page: 1 } })
    }
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items
      .getItems('news', params)
      .then(({ data }) => {
        commit('SET_NEWS', data)
        resolve()
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
  getNewsFilters({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items
      .getFilters('news')
      .then(({ data }) => {
        commit('SET_NEWS_FILTERS', data)
        resolve()
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
  getTopicFilter({ commit }, key) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items
        .getItem(`news.topic_filter.${key}`)
        .then(({ data }) => {
          commit('SET_TOPIC_FILTERS', data)
          resolve()
        })
        .finally(_ => {
          commit('SET_PENDING', false)
        })
    })
  },
  filterNews({ commit, state }, { page }) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items
        .filterItems('news', {
          ...state.filters,
          page,
        })
        .then(({ data }) => {
          commit('SET_NEWS', data)
          commit('SET_FILTER_ACTIVE')
          resolve()
        })
        .finally(_ => {
          commit('SET_PENDING', false)
        })
    })
  },
  getTopTeaser({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)
      this.api.items
      .getItems('news.top_teaser')
      .then(({ data }) => {
        commit('SET_TOP_TEASER', data)
        resolve()
      })
      .finally(_ => {
        commit('SET_PENDING', false)
      })
    })
  },
  setFilterActive({ commit }) {
    commit('SET_FILTER_ACTIVE')
  },
  updateFilters({ commit }, data) {
    commit('UPDATE_FILTERS', data)
  },
  resetFilter({ commit }) {
    commit('RESET_FILTER')
  },
  resetTopicFilter({ commit }) {
    commit('RESET_TOPIC_FILTERS')
  },
}

/* create mutations dynamically */
const mutations = {
  SET_PENDING: (state, status) => {
    state.pending = status
  },
  SET_NEWS_ITEM: (state, result) => {
    state.newsItem = result
  },
  SET_NEWS: (state, { results, pagination }) => {
    if (pagination.self === 1) {
      state.news = results
      state.pagination = pagination
    } else {
      state.news = state.news.concat(results)
      state.pagination = pagination
    }
  },
  SET_TOP_TEASER: (state, { results, options }) => {
    state.topTeaser.results = results
    state.topTeaser.options = options
  },
  RESET_FILTER: state => {
    state.filterActive = false
    state.filters = {}
  },
  SET_NEWS_FILTERS: (state, data) => {
    state.filterOptions = data
  },
  SET_TOPIC_FILTERS: (state, payload) => {
    const optionIndex = findIndex(state.filterOptions, o => o.id === payload[0].id)
    if (optionIndex === -1) {
      state.filterOptions.splice(1, 0, payload[0])
    } else {
      state.filterOptions.splice(optionIndex, 1, payload[0])
    }
  },
  RESET_TOPIC_FILTERS: state => {
    const topicIndex = state.filterOptions.findIndex(option => option.identifier === 'topics')
    if (topicIndex === -1) {
      state.filterOptions.splice(topicIndex, 0)
    } else {
      state.filterOptions.splice(topicIndex, 1)
    }
  },
  UPDATE_FILTERS: (state, data) => {
    state.filters = data
  },
  SET_FILTER_ACTIVE: state => {
    state.filterActive = true
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
